import React from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"

import styles from "./deviceLinks.css"
import routes from "consts/routes"

import { getAssetURL } from "helpers/static"

const tvImage = getAssetURL("image.deviceLinks.tvImage")
const desktopImage = getAssetURL("image.deviceLinks.desktopImage")
const tabletImage = getAssetURL("image.deviceLinks.tabletImage")
const phoneImage = getAssetURL("image.deviceLinks.phoneImage")

const DeviceLinks = ({ asterix }) => (
  <div className={styles.root}>
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Molotov est disponible sur tous vos écrans</h2>
      <div className={styles.device}>
        <div className={styles.image}>
          <img loading="lazy" src={tvImage} alt="tv" />
        </div>
        <h3 className={styles.subTitle}>Sur votre TV</h3>
        <p className={styles.description}>
          <Link to={routes.deviceAppleTv}>Apple TV</Link>, Nvidia Shield, <Link to={routes.deviceChromecast}>Google Cast</Link>,{" "}
          <Link to={routes.deviceSamsung}>Samsung</Link>, <Link to={routes.deviceLg}>LG</Link>, Sony, TCL, Thomson et Panasonic
        </p>
      </div>

      <div className={styles.device}>
        <div className={styles.image}>
          <img loading="lazy" src={desktopImage} alt="desktop" />
        </div>
        <h3 className={styles.subTitle}>Sur votre ordinateur</h3>
        <p className={styles.description}>
          <Link to={routes.deviceDesktop}>Windows, Mac et Linux</Link>
        </p>
      </div>

      <div className={styles.device}>
        <div className={styles.image}>
          <img loading="lazy" src={tabletImage} alt="tablet" />
        </div>
        <h3 className={styles.subTitle}>Sur votre tablette</h3>
        <p className={styles.description}>
          <Link to={routes.deviceIphone}>iPad</Link> et <Link to={routes.deviceAndroid}>Android</Link>
        </p>
      </div>

      <div className={styles.device}>
        <div className={styles.image}>
          <img loading="lazy" src={phoneImage} alt="phone" />
        </div>
        <h3 className={styles.subTitle}>Sur votre smartphone</h3>
        <p className={styles.description}>
          <Link to={routes.deviceIphone}>iPhone</Link> et <Link to={routes.deviceAndroid}>Android</Link>
        </p>
      </div>
    </div>
    {asterix && <div className={styles.asterixWrapper}>{asterix}</div>}
  </div>
)

DeviceLinks.propTypes = {
  asterix: PropTypes.node,
}

export default DeviceLinks
